// extracted by mini-css-extract-plugin
export default {"gif":"gif_gif__8Ctnq","image":"gif_image__Ii2mO"};